import {ReactNode, useEffect, useRef, useState} from "react";
import lscache from "lscache";

import {PreferencesSurveySource} from "@pg-rp/common-types";

import {PHONE_NUMBER_MODAL_DISMISSED} from "@/features/km_app/constants/storage_keys";
import {HomeMatchAmplitudeLocation} from "@/features/tracking/amplitude/home_match_amplitude_tracker";
import {useGetUserProfileQuery} from "@/features/user/api/user_api";
import {USER_PHONE_NUMBER_MODAL_PROGRESS, UserPhoneNumberModal} from "@/features/user/components/modal/UserPhoneNumberModal";
import {useAppDispatch} from "@/store/hooks/use_app_dispatch";

import {useGetHomeMatchPreferencesQuery} from "../api/get_home_match_preferences";
import {HomeMatchPreferencesWizardHost} from "../components/home_match_preferences_wizard/HomeMatchPreferencesWizardHost";
import {IHomeMatchPreferencesWizardRequest} from "../hooks/use_home_match_tinder_unlock";
import {requestHomeMatchRecommendationsOpen} from "../state/home_match_slice";
import {isUserPreferencesNotFull} from "../utils/is_user_preferences_not_full";
import {useHomeMatchPreferencesSurvey} from "./HomeMatchPreferencesSurveyProvider";

interface IProps {
    children: ReactNode;
}

export const HomeMatchOnboardingProvider = (props: IProps) => {
    const {children} = props;

    const dispatch = useAppDispatch();
    const preferencesSurvey = useHomeMatchPreferencesSurvey();

    const [isPhoneNumberModalOpen, setIsPhoneNumberModalOpen] = useState(false);
    const [wasPhoneNumberModalDismissed, setWasPhoneNumberModalDismissed] = useState(() => Boolean(lscache.get(PHONE_NUMBER_MODAL_DISMISSED)));
    const [emptySurveyWizardRequest, setEmptySurveyWizardRequest] = useState<IHomeMatchPreferencesWizardRequest | null>(null);

    const closedEmptySurveyWizardRef = useRef(false);

    const {data: userData, isLoading: isUserDataLoading} = useGetUserProfileQuery(undefined, {skip: wasPhoneNumberModalDismissed});
    const {data: userPreferences, isLoading: isPreferencesLoading, isSuccess: isPreferencesSuccess} = useGetHomeMatchPreferencesQuery();

    const userPreferencesNotFull = (userPreferences && isUserPreferencesNotFull(userPreferences)) ?? true;
    const isSurveyEmpty = isPreferencesSuccess && userPreferences === null;
    const shouldOpenPhoneModal = userData && !userData.phone && !userPreferencesNotFull && !wasPhoneNumberModalDismissed;

    useEffect(() => {
        if (isPreferencesLoading || isUserDataLoading) return;

        if (isSurveyEmpty && !closedEmptySurveyWizardRef.current) setEmptySurveyWizardRequest((current) => current ?? {entry: "homeMatch"});
        if (shouldOpenPhoneModal) setIsPhoneNumberModalOpen(true);
    }, [isPreferencesLoading, isSurveyEmpty, isUserDataLoading, shouldOpenPhoneModal]);

    const handleClosePhoneNumberModal = () => {
        setIsPhoneNumberModalOpen(false);
        lscache.set(PHONE_NUMBER_MODAL_DISMISSED, true);
        setWasPhoneNumberModalDismissed(true);
    };

    const handleCloseEmptySurveyWizard = () => {
        closedEmptySurveyWizardRef.current = true;
        setEmptySurveyWizardRequest(null);
    };

    const handleOpenFullSurvey = () => {
        handleCloseEmptySurveyWizard();
        preferencesSurvey.open({source: PreferencesSurveySource.ONBOARDING});
    };

    const handleFinishEmptySurveyWizard = () => {
        handleCloseEmptySurveyWizard();
        dispatch(requestHomeMatchRecommendationsOpen());
    };

    return (
        <>
            {isPhoneNumberModalOpen && (
                <UserPhoneNumberModal isOpen={isPhoneNumberModalOpen} onCloseButton={handleClosePhoneNumberModal} progress={USER_PHONE_NUMBER_MODAL_PROGRESS} />
            )}

            <HomeMatchPreferencesWizardHost
                amplitudeLocation={HomeMatchAmplitudeLocation.PREFERENCES_AFTER_LOGIN}
                isOpen={emptySurveyWizardRequest !== null}
                onClose={handleCloseEmptySurveyWizard}
                onOpenFullSurvey={handleOpenFullSurvey}
                onSurveyStepsDone={handleFinishEmptySurveyWizard}
                preferencesSurveySource={PreferencesSurveySource.ONBOARDING}
                request={emptySurveyWizardRequest}
            />

            {children}
        </>
    );
};
import {ReactNode, useEffect, useRef, useState} from "react";
import lscache from "lscache";

import {PreferencesSurveySource} from "@pg-rp/common-types";

import {PHONE_NUMBER_MODAL_DISMISSED} from "@/features/km_app/constants/storage_keys";
import {HomeMatchAmplitudeLocation} from "@/features/tracking/amplitude/home_match_amplitude_tracker";
import {useGetUserProfileQuery} from "@/features/user/api/user_api";
import {USER_PHONE_NUMBER_MODAL_PROGRESS, UserPhoneNumberModal} from "@/features/user/components/modal/UserPhoneNumberModal";
import {useAppDispatch} from "@/store/hooks/use_app_dispatch";

import {useGetHomeMatchPreferencesQuery} from "../api/get_home_match_preferences";
import {HomeMatchPreferencesWizardHost} from "../components/home_match_preferences_wizard/HomeMatchPreferencesWizardHost";
import {IHomeMatchPreferencesWizardRequest} from "../hooks/use_home_match_tinder_unlock";
import {requestHomeMatchRecommendationsOpen} from "../state/home_match_slice";
import {isUserPreferencesNotFull} from "../utils/is_user_preferences_not_full";
import {useHomeMatchPreferencesSurvey} from "./HomeMatchPreferencesSurveyProvider";

interface IProps {
    children: ReactNode;
}

export const HomeMatchOnboardingProvider = (props: IProps) => {
    const {children} = props;

    const dispatch = useAppDispatch();
    const preferencesSurvey = useHomeMatchPreferencesSurvey();

    const [isPhoneNumberModalOpen, setIsPhoneNumberModalOpen] = useState(false);
    const [wasPhoneNumberModalDismissed, setWasPhoneNumberModalDismissed] = useState(() => Boolean(lscache.get(PHONE_NUMBER_MODAL_DISMISSED)));
    const [emptySurveyWizardRequest, setEmptySurveyWizardRequest] = useState<IHomeMatchPreferencesWizardRequest | null>(null);

    const closedEmptySurveyWizardRef = useRef(false);

    const {data: userData, isLoading: isUserDataLoading} = useGetUserProfileQuery(undefined, {skip: wasPhoneNumberModalDismissed});
    const {data: userPreferences, isLoading: isPreferencesLoading, isSuccess: isPreferencesSuccess} = useGetHomeMatchPreferencesQuery();

    const userPreferencesNotFull = (userPreferences && isUserPreferencesNotFull(userPreferences)) ?? true;
    const isSurveyEmpty = isPreferencesSuccess && userPreferences === null;
    const shouldOpenPhoneModal = userData && !userData.phone && !userPreferencesNotFull && !wasPhoneNumberModalDismissed;

    useEffect(() => {
        if (isPreferencesLoading || isUserDataLoading) return;

        if (isSurveyEmpty && !closedEmptySurveyWizardRef.current) setEmptySurveyWizardRequest((current) => current ?? {entry: "homeMatch"});
        if (shouldOpenPhoneModal) setIsPhoneNumberModalOpen(true);
    }, [isPreferencesLoading, isSurveyEmpty, isUserDataLoading, shouldOpenPhoneModal]);

    const handleClosePhoneNumberModal = () => {
        setIsPhoneNumberModalOpen(false);
        lscache.set(PHONE_NUMBER_MODAL_DISMISSED, true);
        setWasPhoneNumberModalDismissed(true);
    };

    const handleCloseEmptySurveyWizard = () => {
        closedEmptySurveyWizardRef.current = true;
        setEmptySurveyWizardRequest(null);
    };

    const handleOpenFullSurvey = () => {
        handleCloseEmptySurveyWizard();
        preferencesSurvey.open({source: PreferencesSurveySource.ONBOARDING});
    };

    const handleFinishEmptySurveyWizard = () => {
        handleCloseEmptySurveyWizard();
        dispatch(requestHomeMatchRecommendationsOpen());
    };

    return (
        <>
            {isPhoneNumberModalOpen && (
                <UserPhoneNumberModal isOpen={isPhoneNumberModalOpen} onCloseButton={handleClosePhoneNumberModal} progress={USER_PHONE_NUMBER_MODAL_PROGRESS} />
            )}

            <HomeMatchPreferencesWizardHost
                amplitudeLocation={HomeMatchAmplitudeLocation.PREFERENCES_AFTER_LOGIN}
                isOpen={emptySurveyWizardRequest !== null}
                onClose={handleCloseEmptySurveyWizard}
                onOpenFullSurvey={handleOpenFullSurvey}
                onSurveyStepsDone={handleFinishEmptySurveyWizard}
                preferencesSurveySource={PreferencesSurveySource.ONBOARDING}
                request={emptySurveyWizardRequest}
            />

            {children}
        </>
    );
};
